import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
      name: 'เมนู',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
    },
    username: {
      name: 'Username',
      width: '1fr',
    },
    employeeCode: {
      name: 'Employee Code',
      width: '1fr',
    },
    _activeControls: {
      name: 'Active',
      width: '4rem',
    },
  },
};
